const frequencyOptions = [
  { value: true, label: 'Often' },
  { value: false, label: 'Rarely' },
]

export const questions = [
  {
    name: 'usedProgressiveLenses',
    text: 'Has your client worn progressive lenses before?',
  },
  {
    name: 'further',
    text: 'Further',
    options: frequencyOptions,
  },
  {
    name: 'intermediate',
    text: 'Intermediate',
    options: frequencyOptions,
  },
  {
    name: 'closer',
    text: 'Closer',
    options: frequencyOptions,
  },
]

const Soft = [
  [0, 0 ,1 , 0],
]

const defaultResult = 'Short'

export default {
  questions,
  evaluationMap: { Soft },
  defaultResult,
  title: 'Select frequency of use of vision areas',
}
